/**
 * School User Sections query contract (SCH-2443)
 *
 * GET /v1/schools/:school_public_id/school-users/:user_public_id/sections
 *
 * `SectionMembership` carries a PARENT row for each of a parent's children's sections,
 * so a faculty-parent's full membership set is "the classes I teach" UNION "the classes
 * my child sits in". `parent_memberships` picks which of the two the caller wants:
 *
 *   - absent:    the union when the requester IS the subject; own classes for everyone
 *                else, admins included.
 *   - `include`: the union when the requester is the subject or a school admin /
 *                super-admin; anyone else silently gets own classes (fail closed, no error).
 *   - `exclude`: own classes only, for every requester.
 *
 * "Own classes" still keeps a class the subject holds BOTH ways (a teacher teaching
 * their own child). The signed-in user's own Classes tab and planner omit the param
 * (they want the union); a person's directory profile sends `exclude`; the web admin
 * User Details dialog sends `include`.
 */

import { z } from 'zod'

export const SchoolUserSectionsParentMembershipsSchema = z.enum(['include', 'exclude'])

export type SchoolUserSectionsParentMemberships = z.infer<typeof SchoolUserSectionsParentMembershipsSchema>
